export enum ConfettiTypes {
  LeftToRightBomb = 'leftToRightBomb',
}
